"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function dispatchStorageEvent(key, newValue) {
  window.dispatchEvent(new StorageEvent('storage', {
    key,
    newValue
  }));
}
const getSessionStorageItem = key => {
  return window.sessionStorage.getItem(key);
};
const setSessionStorageItem = (key, value) => {
  const stringifiedValue = JSON.stringify(value);
  window.sessionStorage.setItem(key, stringifiedValue);
  dispatchStorageEvent(key, stringifiedValue);
};
const removeSessionStorageItem = key => {
  window.sessionStorage.removeItem(key);
  dispatchStorageEvent(key, null);
};
const useSessionStorageSubscribe = callback => {
  window.addEventListener('storage', callback);
  return () => window.removeEventListener('storage', callback);
};

/**
 * Custom hook for managing session storage.
 *
 * @param {string} key The key to use for storing the value in session storage
 * @param {*} initialValue The initial value to use if no value is found in session storage
 * @param {number} ttl Time to live in seconds
 * @returns {Array} An array containing the stored value and a function to update the value
 */
function useSessionStorage(key, initialValue, ttl = 1200) {
  const store = (0, _react.useSyncExternalStore)(useSessionStorageSubscribe, () => getSessionStorageItem(key));
  const setValue = (0, _react.useCallback)(value => {
    try {
      if (value == null) {
        removeSessionStorageItem(key);
      } else {
        setSessionStorageItem(key, {
          value,
          expiry: Date.now() + ttl * 1000
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Error setting sessionStorage key "${key}": ${error.message}`);
    }
  }, [key, ttl]);
  (0, _react.useEffect)(() => {
    if (getSessionStorageItem(key) === null && typeof initialValue !== 'undefined') {
      setValue(initialValue);
    }
  }, [key, initialValue, setValue]);
  return [store ? JSON.parse(store) : initialValue, setValue];
}
var _default = exports.default = useSessionStorage;